import { DEFAULT_CARD_BACK, isCollectionImage, type CardBack } from "../shared/collections";
import { t } from "./i18n";

const MARK_PATHS = '<path opacity=".35" d="M15 1A14 14 0 0 0 1 15c0 6 4 11 9 13A14 14 0 0 1 15 1Z"/><path fill-rule="evenodd" d="M18 5a13 13 0 1 0 0 26 13 13 0 0 0 0-26Zm-8 7h4l4 10 4-10h4l-6 15h-4Z"/><path d="m22 1 6 1-1 6-2-3-4 2-1-2 4-2Z"/>';

export function cardBackColor(back?: CardBack): string {
  return back && /^#[a-f\d]{6}$/i.test(back.color) ? back.color : DEFAULT_CARD_BACK.color;
}

/** The same native V artwork is used on screen and by the printable rasterizer. */
export function cardBackLogoSvg(back?: CardBack): string {
  const color = cardBackColor(back);
  const [red, green, blue] = [1, 3, 5].map((offset) => Number.parseInt(color.slice(offset, offset + 2), 16));
  const foreground = red * .2126 + green * .7152 + blue * .0722 > 180 ? "#102233" : "#fff2df";
  return `<svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100"><circle cx="50" cy="50" r="50" fill="${color}"/><circle cx="50" cy="50" r="46.5" fill="none" stroke="${foreground}" stroke-opacity=".45" stroke-width=".5"/><circle cx="50" cy="50" r="43.5" fill="none" stroke="${foreground}" stroke-opacity=".22" stroke-width=".5" stroke-dasharray="1 2"/><g transform="translate(20 18) scale(1.9)" fill="${foreground}">${MARK_PATHS}</g></svg>`;
}

export function createCardBack(back?: CardBack): HTMLElement {
  const root = document.createElement("div");
  root.className = "game-card card-back";
  root.setAttribute("role", "img");
  root.setAttribute("aria-label", t("Dos de carte"));
  root.style.background = cardBackColor(back);
  if (back?.kind === "image" && isCollectionImage(back.image)) {
    const image = document.createElement("img");
    image.src = back.image;
    image.alt = "";
    image.draggable = false;
    image.style.cssText = "display:block;width:100%;height:100%;object-fit:cover;border-radius:50%";
    root.append(image);
  } else {
    root.innerHTML = cardBackLogoSvg(back);
    (root.firstElementChild as SVGElement).style.cssText = "display:block;width:100%;height:100%";
  }
  return root;
}
